// Dynamic imports for Firebase modules (client-side only)
let initializeApp, isSupported, getMessaging, getToken, onMessage;
let getFirestore, collection, addDoc, getDocs, getDoc, doc, setDoc, onSnapshot, updateDoc, deleteDoc;
let getAuth, signInWithCustomToken;
let getFunctions, httpsCallable;

// Lazy load Firebase modules only on client side
const loadFirebaseModules = async () => {
  if (process.client && typeof window !== 'undefined') {
    const firebaseApp = await import("firebase/app");
    const firebaseMessaging = await import("firebase/messaging");
    const firebaseFirestore = await import("firebase/firestore");
    const firebaseAuth = await import("firebase/auth");
    const firebaseFunctions = await import("firebase/functions");
    
    initializeApp = firebaseApp.initializeApp;
    isSupported = firebaseMessaging.isSupported;
    getMessaging = firebaseMessaging.getMessaging;
    getToken = firebaseMessaging.getToken;
    onMessage = firebaseMessaging.onMessage;
    
    ({ getFirestore, collection, addDoc, getDocs, getDoc, doc, setDoc, onSnapshot, updateDoc, deleteDoc } = firebaseFirestore);
    
    ({ getAuth, signInWithCustomToken } = firebaseAuth);
    
    ({ getFunctions, httpsCallable } = firebaseFunctions);
  }
};

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
const mode={
  // chat firebase config

  //  beta : {
  //   firebaseConfig: {
  //     apiKey: "AIzaSyDxxWW0EBeFvgKYraPK81XgBI_5tATveSY",
  //     authDomain: "cezma-chat-68b07.firebaseapp.com",
  //     projectId: "cezma-chat-68b07",
  //     storageBucket: "cezma-chat-68b07.firebasestorage.app",
  //     messagingSenderId: "217921244648",
  //     appId: "1:217921244648:web:b44e28289eec3b1807e85d",
  //     measurementId: "G-R0QYSFJERY"
  //   },
  //   Key_pair: 'BE3FcYJCMbIP2nsEY6P3h27vTEqsQi2BIZ4ZNxCSrVM7ZgXqL4jkb9oRaI9wcDhiGz9q1DAJ3afA3zedQwlVyNs',
  // },

// test firebase config
  beta : {
    firebaseConfig: {
      apiKey: 'AIzaSyC23QyxFJYlDG66PRHcpZbq3sk-T5OD2rU',
      authDomain: 'cezma-test.firebaseapp.com',
      projectId: 'cezma-test',
      storageBucket: 'cezma-test.appspot.com',
      messagingSenderId: '720310463799',
      appId: '1:720310463799:web:c0dc972d6787671c14beb2',
      measurementId: 'G-FK8FJL8DPZ',
    },
    Key_pair: 'BLHS2g0NTtPnr2b-bJ41AOXqg6PaY5lOk-dJTChQDeBAnzo-X2PeokzW14edW5qGFpUSvfIGxs1K_a4_6Hpqbw4',
  },

  production : {
    firebaseConfig: {
      apiKey: 'AIzaSyBQl3gxjPZ1RXUUegprdX9rXoq0K9m3O2U',
      authDomain: 'cezma-65e3a.firebaseapp.com',
      databaseURL: 'https://cezma-65e3a-default-rtdb.europe-west1.firebasedatabase.app',
      projectId: 'cezma-65e3a',
      storageBucket: 'cezma-65e3a.appspot.com',
      messagingSenderId: '899455794450',
      appId: '1:899455794450:web:11211aaf46c847728287cb',
      measurementId: 'G-BHK7M9PRR9',
    },
    Key_pair: 'BHvjyX9voBSwIcca0lOpeEnwEmAJXcwGAlKnu3ZDBTRX5fDXgtXnfOIvk_6GIiXnu65qeWH0JwXlBL3RakRVO1Y',
}

}

//first Checks if all required APIs exist in the browser.
//web app's Firebase configuration For Firebase JS SDK v7.20.0 and later, measurementId is optional
const isProduction = process.env.NODE_ENV === 'production';
const activeFBConfig = process.client ? isProduction ? mode.production : mode.beta : {firebaseConfig: {}, Key_pair: ""};
export const firebaseConfig = activeFBConfig.firebaseConfig;

let app = {};
let messaging = {};
const vap_id_key = activeFBConfig.Key_pair;
let webDeviceToken = [];
// Initialize Firestore
let db = {};
let functions = {};
let firebaseInitialized = false;
let firebaseInitPromise = null;

// Initialize Firebase only on client side
const initFirebase = async () => {
  if (!process.client) {
    return;
  }
  
  if (firebaseInitialized) {
    return;
  }
  
  if (firebaseInitPromise) {
    return firebaseInitPromise;
  }
  
  firebaseInitPromise = (async () => {
    try {
      // Load Firebase modules first
      await loadFirebaseModules();
      
      if (!isSupported) {
        console.warn('Firebase messaging not supported');
        return;
      }
      
      const supported = await isSupported();
      if (supported) {
        // Initialize Firebase
        app = initializeApp(firebaseConfig);
        // Get registration token. Initially this makes a network call, once retrieved subsequent calls to getToken will return from cache.
        messaging = getMessaging(app);
        db = getFirestore(app);
        functions = getFunctions(app);
        firebaseInitialized = true;
      }
    } catch (error) {
      console.error('Firebase initialization error:', error);
      firebaseInitPromise = null; // Reset on error so it can be retried
    }
  })();
  
  return firebaseInitPromise;
};

// Auto-initialize on client side
if (process.client) {
  initFirebase();
}

export const getFirebaseToken = async () => {
  if (!process.client) {
    return Promise.reject("Firebase is only available on client side");
  }
  
  // Ensure Firebase is initialized
  await initFirebase();
  
  // Handle Firebase setup and token retrieval here...
  return new Promise((resolve, reject) => {
    if (!isSupported) {
      reject("Firebase messaging not supported");
      return;
    }
    
    isSupported()
      .then(() => {
        if (!messaging || !vap_id_key) {
          reject("Firebase not initialized");
          return;
        }
        getToken(messaging, { vapidKey: vap_id_key })
          .then((currentToken) => {
            if (currentToken) {
              // Send the token to your server and update the UI if necessary
              //currentToken--> is FCM registration token is send to server so it can send you a message
              resolve(currentToken);
            } else {
              // Show permission request UI
              resolve(
                "No registration token available. Request permission to generate one."
              );
            }
          })
          .catch((err) => {
            reject(err);
          });
      })
      .catch(() => {
        reject("not supported");
      });
  });
};
export const firebaseMessage = (() => {
  const listeners = [];
  let message = null;

  const notifyListeners = (newValue) => {
    for (const listener of listeners) {
      listener(newValue);
    }
  };

  const setMessage = (value) => {
    if (message !== value) {
      message = value;
      notifyListeners(value);
    }
  };

  const addListener = (listener) => {
    listeners.push(listener);
    // Return a function that can be used to remove this specific listener

    return () => {
      const index = listeners.indexOf(listener);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
    };
  };

  const removeListener = (listener) => {
    const index = listeners.indexOf(listener);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  };

  return {
    get message() {
      return message;
    },
    set message(value) {
      setMessage(value);
    },
    addListener,
    removeListener, // Add a method to remove a specific listener
  };
})();
// Setup message listener only on client side
if (process.client) {
  initFirebase().then(() => {
    if (isSupported && messaging) {
      isSupported().then(() => {
        onMessage(messaging, (payload) => {
          try {
            firebaseMessage.message = payload;
          } catch (err) {
            console.error(err);
          }
        });

        const channel = new BroadcastChannel("sw-messages"); //recive from same channel that created in service worker
        channel?.addEventListener("message", (event) => {
          try {
            let payload = event.data;
            firebaseMessage.message = JSON.parse(payload);
          } catch (err) {
            console.error(err);
          }
        });
      });
    }
  });
}

export const deleteGroup = async (groupId) => {
  if (!process.client) {
    throw new Error("Firebase is only available on client side");
  }
  await initFirebase();
  if (!db || !doc || !deleteDoc) {
    throw new Error("Firebase Firestore not initialized");
  }
  const groupRef = doc(db, "Groups", groupId);
  await deleteDoc(groupRef).catch((error) => console.error("Error removing document: ", error));
  return true;
};
export const getAuthFirebase = async (userObject) => {
  if (!process.client) {
    throw new Error("Firebase is only available on client side");
  }
  await initFirebase();
  if (!getAuth || !signInWithCustomToken) {
    throw new Error("Firebase Auth not initialized");
  }
  const auth = getAuth(); 
  await signInWithCustomToken(auth, userObject?.token);
};
export const addDocument = async (groupId, collectionName, data,userObject) => {
  if (!process.client) {
    throw new Error("Firebase is only available on client side");
  }
  await initFirebase();
  if (!db || !collection || !addDoc || !getDoc || !setDoc || !doc) {
    throw new Error("Firebase Firestore not initialized");
  }
  const collectionRef = collection(db, "Groups", groupId, collectionName);
  const docRef = await addDoc(collectionRef, data);
  const docSnapshot = await getDoc(docRef);
  const docData = docSnapshot.data();
  await setDoc(doc(db, "Groups", groupId), { lastMsg: docData }, { merge: true });
  const dataToSend = {
    type: "message",
    title: "رسالة جديدة",
    body: docData.type === "audio" ? "رسالة صوتية" : docData.type === "video" ? "فيديو تصويري" : docData.type === "image" ? "صورة" : docData.type === "location" ? "موقع" : docData.type === "product" ? "استفسار عن منتج او متجر" : docData.type === "text" ? docData.textMsg : docData.textMsg,
    call: null,
    senderId: docData.senderId,
    groupId: groupId,
  };
  await sendNotification(userObject,dataToSend);
  return docData;
};
export const filterDeviceToken = async (deviceToken,groupId,userObject) => {
  if (!process.client) {
    throw new Error("Firebase is only available on client side");
  }
  await initFirebase();
  if (!db || !getDoc || !doc || !getDocs || !collection) {
    throw new Error("Firebase Firestore not initialized");
  }
  const groupMembersUid = (await getDoc(doc(db, "Groups", groupId))).data().members;
  const usersDocSnapshot = await getDocs(collection(db, "Users"));;
  const ExcludedUserWebToken = usersDocSnapshot.docs.find(doc => doc.id === userObject.userID).data()?.webDeviceToken;
  const ExcludedUserDevicesTokens = usersDocSnapshot.docs.find(doc => doc.id === userObject.userID).data()?.deviceTokens;
  const mergeExcludedUserDevicesTokens = [...new Set([ExcludedUserWebToken?.flat(), ...ExcludedUserDevicesTokens?.flat()])];
  const usersDocData = usersDocSnapshot.docs.map(doc => groupMembersUid.includes(doc.id) ? doc.data() : false).filter(user => user !== false);
  const filteredWebDeviceToken = usersDocData.map(user => user.webDeviceToken?.filter(token => token !== deviceToken || []).flat());
  const filteredDeviceToken = usersDocData.map(user => user.deviceTokens?.filter(token => token !== deviceToken || []).flat());
  const mergedDeviceToken = [...new Set(filteredWebDeviceToken.flat().concat(filteredDeviceToken.flat()))].filter(token => !mergeExcludedUserDevicesTokens.includes(token)).filter(Boolean);
  return mergedDeviceToken;
}
export const updatewebDeviceToken = async (userObject,deviceToken) => {
  if (!process.client) {
    throw new Error("Firebase is only available on client side");
  }
  await initFirebase();
  if (!db || !doc || !getDoc || !setDoc) {
    throw new Error("Firebase Firestore not initialized");
  }
  // if(webDeviceToken.length > 0){
  //   return true;
  // }else{
    const userDoc = doc(db, "Users", userObject.userID);
    const userDocSnapshot = await getDoc(userDoc);
    const userDocData = userDocSnapshot.data();
    const updatedWebDeviceToken = userDocData?.webDeviceToken || [];
    const updatedDeviceToken = userDocData?.deviceTokens || [];
    if (!updatedWebDeviceToken.includes(deviceToken)) {
      updatedWebDeviceToken.push(deviceToken);
    }
    if (!updatedDeviceToken.includes(deviceToken)) {
      updatedDeviceToken.push(deviceToken);
    }
    await setDoc(userDoc, { webDeviceToken: updatedWebDeviceToken, deviceTokens: updatedDeviceToken }, { merge: true });
    return true;
  // }
};
export const sendNotification = async (userObject, data) => {
  if (!process.client) {
    throw new Error("Firebase is only available on client side");
  }
  await initFirebase();
  if (!functions || !httpsCallable) {
    throw new Error("Firebase Functions not initialized");
  }
  webDeviceToken = await requestPermission(userObject);
  const sendPushNotification = httpsCallable(functions, "sendPushNotification");
  data.deviceTokens = await filterDeviceToken(webDeviceToken,data.groupId,userObject);
  try {
   await sendPushNotification(data);
  } catch (error) {
    console.error("Error sending notification:", error);
  }
};
export const requestPermission = async (userObject) => {
  if (!process.client) {
    throw new Error("Firebase is only available on client side");
  }
  await initFirebase();
  if (!getToken || !messaging || !vap_id_key) {
    throw new Error("Firebase Messaging not initialized");
  }
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      // if(webDeviceToken.length > 0){
      //   return webDeviceToken;
      // }else{
          // Get the device token
          const token = await getToken(messaging, {
          vapidKey: vap_id_key, // Get this from Firebase Console
        });
        if (token) {
          await updatewebDeviceToken(userObject,token);
          return token;
        } else {
        }
      // }
    } else {
    }
  } catch (error) {
  }
};
export const getGroupDocuments = async (userObject, callback, options = {}) => {
  if (!process.client) {
    throw new Error("Firebase is only available on client side");
  }
  await initFirebase();
  if (!getAuth || !signInWithCustomToken || !db || !collection || !onSnapshot) {
    throw new Error("Firebase not initialized");
  }
  try {
    const auth = getAuth(); 
    await signInWithCustomToken(auth, userObject?.token);

    const { includeMessages = false } = options;
    const documents = []; 
    const unsubscribe = onSnapshot(
      collection(db, "Groups"), 
      async (querySnapshot) => { 
        documents.length = 0; 
        
        // Use Promise.all with map instead of forEach to fix race condition
        const groupPromises = Array.from(querySnapshot.docs).map(async (doc) => {
          const groupData = doc.data().members.includes(userObject?.userID) ? { id: doc.id, ...doc.data() } : false;
          if (groupData) {
            // Only fetch messages if explicitly requested (not needed for contacts list)
            if (includeMessages && getDocs) {
              const messagesQuerySnapshot = await getDocs(collection(db, "Groups", doc.id, "Messages"));
              const messages = messagesQuerySnapshot.docs.map(messageDoc => ({ id: messageDoc.id, ...messageDoc.data() }));
              groupData.messages = messages;
            } else {
              // For contacts list, we only need lastMsg which is already in the group document
              groupData.messages = [];
            }
            return groupData;
          }
          return null;
        });
        
        // Wait for all async operations to complete
        const groups = await Promise.all(groupPromises);
        const validGroups = groups.filter(group => group !== null);
        documents.push(...validGroups);
        
        callback(documents);
      },
      (error) => {
        // Handle Firestore listener errors
        console.error("Firestore listener error: ", error);
        
        // Check if error is due to blocked request (ad blocker, etc.)
        if (error?.code === 'unavailable' || error?.message?.includes('ERR_BLOCKED_BY_CLIENT') || 
            error?.message?.includes('network') || error?.message?.includes('blocked')) {
          console.warn("Firestore connection blocked. This may be due to an ad blocker or browser extension. Please disable extensions blocking Firebase requests.");
          // Optionally show user-friendly error message
          if (typeof callback === 'function') {
            callback([]); // Return empty array to prevent UI errors
          }
        } else {
          // Re-throw other errors
          throw error;
        }
      }
    );

    return unsubscribe; 
  } catch (error) {
    console.error("Error fetching group documents: ", error.message); 
    
    // Handle blocked requests gracefully
    if (error?.message?.includes('ERR_BLOCKED_BY_CLIENT') || 
        error?.message?.includes('blocked') ||
        error?.code === 'unavailable') {
      console.warn("Firestore connection blocked. This may be due to an ad blocker or browser extension.");
      // Return a no-op unsubscribe function
      return () => {};
    }
    
    throw new Error(`Failed to fetch group documents: ${error.message}`); 
  }
};
export const getUserDocuments = async (idToken, userIds = null) => {
  if (!process.client) {
    throw new Error("Firebase is only available on client side");
  }
  await initFirebase();
  if (!getAuth || !signInWithCustomToken || !db || !collection || !getDocs || !getDoc || !doc) {
    throw new Error("Firebase not initialized");
  }
  try {
    const auth = getAuth(); 
    await signInWithCustomToken(auth, idToken);

    const documents = [];
    
    // Optimize: Only fetch specific users if userIds provided
    if (userIds && Array.isArray(userIds) && userIds.length > 0) {
      // Fetch users by their document IDs in parallel
      const userPromises = userIds.map(async (userId) => {
        try {
          const userDoc = await getDoc(doc(db, "Users", userId));
          if (userDoc.exists()) {
            return { id: userDoc.id, ...userDoc.data() };
          }
          return null;
        } catch (error) {
          console.error(`Error fetching user ${userId}:`, error);
          return null;
        }
      });
      
      const userResults = await Promise.all(userPromises);
      documents.push(...userResults.filter(user => user !== null));
    } else {
      // Fallback: fetch all users if no userIds provided
      const querySnapshot = await getDocs(collection(db, "Users"));
      querySnapshot.forEach((doc) => {
        documents.push({ id: doc.id, ...doc.data() });
      });
    }
    
    return documents;
  } catch (error) {
    console.error("Error fetching user documents: ", error.message); 
    throw new Error(`Failed to fetch user documents: ${error.message}`); 
  }
};
export const getMessages = async (userObject, groupId, callback) => {
  if (!process.client) {
    throw new Error("Firebase is only available on client side");
  }
  await initFirebase();
  if (!getAuth || !signInWithCustomToken || !db || !collection || !onSnapshot || !doc || !getDoc || !updateDoc || !setDoc) {
    throw new Error("Firebase not initialized");
  }
  const auth = getAuth(); 
  return signInWithCustomToken(auth, userObject?.token) 
    .then(async () => {
      const messagesRef = collection(db, "Groups", groupId, "Messages"); 
      return onSnapshot(
        messagesRef, 
        async (snapshot) => { 
          const collectionRef = doc(db, "Groups", groupId);
          const collectionSnapshot = await getDoc(collectionRef);
          const unreadList = collectionSnapshot.data()?.unreadList;
          if(unreadList && unreadList[userObject.userID]){
            const unreadListAfter = { ...unreadList };
            Object.keys(unreadListAfter).forEach(key => {
              if (key === userObject.userID) {
                delete unreadListAfter[key];
              }
            });
            await updateDoc(collectionRef, { unreadList: unreadListAfter });
          }
          const messages = snapshot.docs.map(doc => {
            const data = doc.data();
            return { id: doc.id, sentAt: data.sendAt ? data.sendAt.seconds * 1000 : null, ...data };
          });
          messages.sort((a, b) => b.sentAt - a.sentAt);
          messages.forEach(message => {
            if(message.senderId !== userObject.userID){
              setDoc(doc(db, "Groups", groupId, "Messages", message.id), {isRead: true}, {merge: true});
            }
          });
          callback(messages);
        },
        (error) => {
          // Handle Firestore listener errors
          console.error("Firestore messages listener error: ", error);
          
          // Check if error is due to blocked request (ad blocker, etc.)
          if (error?.code === 'unavailable' || error?.message?.includes('ERR_BLOCKED_BY_CLIENT') || 
              error?.message?.includes('network') || error?.message?.includes('blocked')) {
            console.warn("Firestore connection blocked. This may be due to an ad blocker or browser extension. Please disable extensions blocking Firebase requests.");
            // Return empty array to prevent UI errors
            callback([]);
          } else {
            // Re-throw other errors
            throw error;
          }
        }
      );
    })
    .catch((error) => {
      console.error("Error signing in: ", error.message); 
      
      // Handle blocked requests gracefully
      if (error?.message?.includes('ERR_BLOCKED_BY_CLIENT') || 
          error?.message?.includes('blocked') ||
          error?.code === 'unavailable') {
        console.warn("Firestore connection blocked. This may be due to an ad blocker or browser extension.");
        // Return a no-op unsubscribe function
        return () => {};
      }
      
      throw new Error(`Failed to sign in: ${error.message}`); 
    });
};
